export const genericErrorModalKeys = [
  {
    id: "mybag_genericError_modal_header",
    defaultValue: "Let's give that another shot!"
  },
  {
    id: "mybag_genericError_primary_CTA",
    defaultValue: "REFRESH PAGE"
  },
  {
    id: "mybag_genericError_modal_desc",
    defaultValue:
      "It looks like something went wrong. Refresh your page and try again."
  }
];

export const removeItemModalKeys = [
  {
    id: "mybag.oneListSection.multiListItemRemovalConfirmationModal.message",
    defaultValue: "The item will be removed from all lists."
  },
  {
    id: "mybag.common.oos-modal-close-label",
    defaultValue: "Close"
  },
  {
    id: "mybag.product.remove-confirmation-header",
    defaultValue: "Are you sure you want to remove this item from your bag?"
  },
  {
    id: "mybag.product.remove-confirm",
    defaultValue: "YES, REMOVE THIS ITEM"
  },
  {
    id: "mybag.product.remove-cancel",
    defaultValue: "No, keep this item"
  }
];
